import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SquidexService } from '../../../../services/squidex.service'
import { Subscription } from 'rxjs'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { take } from 'rxjs/operators'

@Component({
  selector: 'flowaccount-business-service',
  templateUrl: './business-service.component.html',
  styleUrls: ['./business-service.component.scss'],
})
export class BusinessServiceComponent implements OnInit, OnDestroy {
  public ServiceList: any
  private subscriptions: Subscription[] = []
  private contentScully = 'BUSINESS_REGISTRATION_BUSINESS_SERVICE'
  constructor(
    public translate: TranslateService,
    public cdref: ChangeDetectorRef,
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
  ) {}
  ngOnInit(): void {
    // After scully builded
    if (isScullyGenerated()) {
      this.tstate.useScullyTransferState(this.contentScully, this.ServiceList).subscribe((data: object[]) => {
        this.ServiceList = data
        this.cdref.markForCheck()
      })
    } else {
      // run every build
      this.getTotalService()
    }
  }
  getTotalService() {
    this.subscriptions.push(
      this.squidexService
        .getContentSquidexApiOrder('business-registration-service')
        .pipe(take(1))
        .subscribe((data: object[]) => {
          this.ServiceList = data
          this.tstate.setState(this.contentScully, data)
          this.cdref.markForCheck()
        }),
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe())
  }
}
